import React from "react";
import Image from "react-bootstrap/Image";
import Fillter from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";

export const AllVendorTableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "12%" }}>
        Business
        <br />
        Id
      </th>
      <th style={{ width: "14%" }}>Business Name</th>
      <th style={{ width: "18%" }}>Primary Contact</th>
      <th style={{ width: "16%" }}>Address</th>
      <th style={{ width: "10%" }}>
        Profile
        <br />
        Completion %
      </th>
      <th style={{ width: "12%" }}>Restaurant Type</th>
      {props.displayStatus ? <th style={{ width: "8%" }}>Status</th> : null}
      <th
        style={
          props.displayStatus
            ? { width: "12%", textAlign: "right" }
            : { width: "18%", textAlign: "right" }
        }
      >
        Actions
        {/* <div className="d-flex justify-content-between">
          <div>Actions</div>
          <div className="d-flex align-items-center ">
            <Image
              fluid
              src={require("../../../../../../assets/images/superadmin/sort-button-with-three-lines.svg")}
              className="sort-image"
            />
            <div className="ml-3">
              <Fillter />
            </div>
          </div>
        </div> */}
      </th>
    </tr>
  );
};
